import {
  Action,
  ActionType,
  FullStressTypeCSVDownloadResponse,
} from "models/stressCheck/fullStressTypeDownloadCsv";
import createReducer from "redux/createReducer";

export interface FullStressCSVDownloadReducerType {
  loading: boolean;
  error?: string;
  fullStressCsvDownloadResponse?: FullStressTypeCSVDownloadResponse;
}

const defaultState: FullStressCSVDownloadReducerType = {
  loading: false,
  error: undefined,
  fullStressCsvDownloadResponse: undefined,
};

export const fullStressCsvDownloadReducer =
  createReducer<FullStressCSVDownloadReducerType>(defaultState, {
    [ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV](
      state: FullStressCSVDownloadReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV_ERROR](
      state: FullStressCSVDownloadReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV_SUCCESS](
      state: FullStressCSVDownloadReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressCsvDownloadResponse: action.payload,
      };
    },

    [ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV_RESET_DATA](
      state: FullStressCSVDownloadReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressCsvDownloadResponse: [],
      };
    },
  });
